angular.module('core')
  .provider('dblIaplService', function() {

    var provider = {
      $get: [
        '$log',
        '$rootScope',
        '$q',
        'activityApi',
        'classroomApi',
        'iaplApi',
        'configuration',
        'cancelableResourceManager',
        'dblAnalyticsProvider',
        'authentication',
        'assignedFocusApi',
        function(
          $log,
          $rootScope,
          $q,
          activityApi,
          classroomApi,
          iaplApi,
          $configuration,
          cancelableResourceManager,
          dblAnalytics,
          dblAuthentication,
          assignedFocusApi) {

          var rawActivities;
          var rawProgresses;
          var rawReportDates;
          var rawPdContents;

          function getProgress(progresses, lessonGroupName) {
            return progresses[lessonGroupName] ? progresses[lessonGroupName].progress : 0;
          }

          function getLastAccessed(progress, lessonGroupName) {
            return progress[lessonGroupName] ? progress[lessonGroupName].last_accessed : null;
          }

          function transformLists(activities, progresses, filters) {
            var lessonGroups = {},
              students = {},
              lgArray = [],
              studentArray = [];

            _.forEach(activities, function(activity) {
              if (activity.dbl_standard && activity.dbl_standard.name && activity.dbl_standard.short_description) {
                var lessonGroup = activity.dbl_standard;

                //process by lesson group
                var includeAf = filters.includeAssignFocusActivities === true || activity.assignment_id === null;
                if (lessonGroups[lessonGroup.name]) {
                  if (includeAf === true) {
                    lessonGroups[lessonGroup.name].count++;
                  }
                }
                else {
                  lessonGroups[lessonGroup.name] = _.extend({
                    studentIds: {},
                    count: includeAf === true ? 1 : 0,
                    demo_lesson_name: activity.demo_lesson_name,
                    standards: activity.standards,
                    lesson_goal_id: activity.lesson_goal_id,
                    progress: getProgress(progresses, lessonGroup.name),
                  }, lessonGroup);
                }

                if (includeAf) {
                  //save student ids into a hash now, so later we can use it to get the unique student counts
                  lessonGroups[lessonGroup.name].studentIds[activity.student_id] = true;
                }

                if (filters.includeAssignFocusActivities === true && activity.assignment_id !== null) {
                  lessonGroups[lessonGroup.name].hasAssignFocus = true;
                  lessonGroups[lessonGroup.name].showLongAssignment = assignedFocusApi.isLongTermAssignment(activity);
                }

                //process by student
                if (students[activity.student_id]) {
                  students[activity.student_id].count++;
                  if (students[activity.student_id].mostRecentTimestamp < activity.timestamp) {
                    //set the lessonGroup.name and Description for the most recently active one
                    students[activity.student_id].mostRecentTimestamp = activity.timestamp;
                    students[activity.student_id].mostRecentLessonGroupDesc = lessonGroup.short_description;
                    students[activity.student_id].mostRecentLessonGoalId = lessonGroup.lesson_goal_id;
                    students[activity.student_id].name = lessonGroup.name;
                  }
                }
                else {
                  students[activity.student_id] = _.extend({
                    count: 1,
                    student_id: activity.student_id,
                    first_name: activity.first_name,
                    last_name: activity.last_name,
                    lesson_goal_id: activity.lesson_goal_id,
                    demo_lesson_name: activity.demo_lesson_name,
                    standards: activity.standards,
                    assignment_id: activity.assignment_id,
                    mostRecentTimestamp: activity.timestamp,
                    mostRecentLessonGroupDesc: lessonGroup.short_description,
                    mostRecentLessonGoalId: lessonGroup.lesson_goal_id,
                    name: lessonGroup.name
                  }, lessonGroup);
                }
              }
            });

            _.forEach(lessonGroups, function(lessonGroup) {
              if (lessonGroup.count > 0) {
                lgArray.push(lessonGroup);
              }
            });

            _.forEach(students, function(item) {
              studentArray.push(item);
            });

            return {
              lessonGroups: lgArray,
              studentLessonGroups: studentArray,
              reportDates: rawReportDates
            };
          }

          function combinePdContentAndProgress(progresses, pdContents) {
            _.forEach(progresses, function(value, key) {
               _.assign(pdContents[key], value);
            });

            return pdContents;
          }

          function getLists(filters) {
            var deferred = $q.defer();
            var sy = null;
            var fd = null;
            var td = null;

            var isConceptMapMode = filters.context === 'concept-map';

            var days = isConceptMapMode ? $configuration.getConceptMapActivityDays() :
                $configuration.getIaplActivityDays(); //should be 7 days

            var activitiesPromise = activityApi.getIaplActivities(filters.viewMode, sy, days, fd, td, null);

            var progressPromise;

            // TODO: Verify this doesnst break anything for guardians
            //create a resolved promise for non IAPL customers, who don't have progress data
            var progressDeferred = $q.defer();
            progressDeferred.resolve({
              data: {}
            });
            progressPromise = {
              $promise: progressDeferred.promise
            };


            var promises = {
              activities: activitiesPromise.$promise,
              progresses: progressPromise.$promise
            };

            var pidActivities = cancelableResourceManager.add(activitiesPromise),
              pidProgresses = cancelableResourceManager.add(progressPromise);

            $q.all(promises).then(function(response) {
              cancelableResourceManager.remove(pidActivities);
              cancelableResourceManager.remove(pidProgresses);

              /*
                  de-dup lesson_goal_id, dbl_standard.name
                  Multiple lesson_goal_id's can share the same dreambox standard name
                  and data is lesson_goal_id, student_id grouped

                  todo: This should be refactored along with refactoring g2 to return data more specific to this need
                  and less a copy of Activity Feed
              */
              var deduped = {};
              _.forEach(response.activities.events, function(a) {
                var key = a.student_id + '||' + a.lessonGroupName;
                if (!deduped[key]) {
                  deduped[key] = a;
                }
              });
              rawActivities = _.map(deduped, function(item) {
                return item;
              });

              rawProgresses = response.progresses.data;
              rawReportDates = response.activities.reportDates;

              deferred.resolve(transformLists(rawActivities, rawProgresses, filters));
            });

            return deferred.promise;
          }

          function getAccessId(success, error) {
            iaplApi.getAccessId(success, error);
          }

          function getPdLocations(keys, success, error) {
            var resource = iaplApi.getPdLocations(keys);
            resource.$promise.then(success, error);
            return resource;
          }

          function getPdContents() {
            var deferred = $q.defer();
            var sy = null;
            var fd = null;
            var td = null;
            var days = $configuration.getIaplActivityDays(); //should be 7 days

            var progressPromise = iaplApi.getPdProgress(sy, days, fd, td);
            var pdContentsPromise = iaplApi.getPdContents();

            var promises = {
              progresses: progressPromise.$promise,
              pdContents: pdContentsPromise.$promise
            };

            var pidProgresses = cancelableResourceManager.add(progressPromise);
            var pidPdContents = cancelableResourceManager.add(pdContentsPromise);

            $q.all(promises).then(function(response) {
              cancelableResourceManager.remove(pidProgresses);
              cancelableResourceManager.remove(pidPdContents);
              rawProgresses = response.progresses.data;
              rawPdContents = response.pdContents.data;
              deferred.resolve(combinePdContentAndProgress(rawProgresses, rawPdContents));
            });

            return deferred.promise;
          }

          function isMoodleUrl(url) {
             return (url !== null) && (url.length > 0) && url.search(/^http[s]?:\/\//) === -1;
          }

          function retrievePdLocations(lessonGroupNames) {
            var deferred = $q.defer();

            if (lessonGroupNames === null || lessonGroupNames.length === 0) {
              deferred.resolve({});
              return deferred.promise;
            }

            var resource = getPdLocations(_.uniq(lessonGroupNames),
              function(locations) {
                cancelableResourceManager.remove(pid);
                var pdLocations = {};
                _.forEach(locations, function(value, key) {
                  if (isMoodleUrl(value)) {
                    pdLocations[key] = value;
                }
              });

              deferred.resolve(pdLocations);
            });

            var pid = cancelableResourceManager.add(resource);
            return deferred.promise;
          }

          function afIncludedLabel(includeAssignFocusActivities) {
            return "afIncluded: " + includeAssignFocusActivities;
          }

          return {
            // get PDOD access Id for the signed in user
            getAccessId: getAccessId,

            // get iapl lesson group and student goal data
            getLists: getLists,

            // filter activities based on af preference
            filterActivities: function(filters) {
              return transformLists(rawActivities, rawProgresses, filters);
            },

            getLessonGroups: function(studentId) {
              var lessonGroups = rawActivities.filter(function(item) {
                return (item.student_id === studentId);
              }).sort(function(a, b) {
                return a.timestamp < b.timestamp;
              });
              return lessonGroups;
            },

            getStudents: function(lessonGroupName, includeAssignFocusActivities) {
              var students = rawActivities.filter(function(item) {
                return (item.dbl_standard &&
                  item.dbl_standard.name === lessonGroupName &&
                    (includeAssignFocusActivities || item.assignment_id === null));
              }).sort(function(a, b) {
                return a.first_name > b.first_name;
              });
              return students;
            },

            // log event to analytics service
            logEvent: function(action, event, includeAssignFocusActivities) {
              event = event || {
                category: 'Lesson Group Preview',
                eventType: 'click'
              };
              event.category = event.category || 'Lesson Group Preview';
              event.eventType = event.eventType || 'click';

              if (!_.isUndefined(includeAssignFocusActivities)) {
                event.label = event.label ? event.label + ', ' : '';
                event.label += afIncludedLabel(includeAssignFocusActivities);
              }
              dblAnalytics.eventTrack(action, event);
            },


            // log pd event to analytics service
            logPdEvent: function(action, event, includeAssignFocusActivities) {
              event = event || {
                category: 'MyFlexPD',
                eventType: 'click'
              };
              event.category = event.category || 'MyFlexPD';
              event.eventType = event.eventType || 'click';

              if (!_.isUndefined(includeAssignFocusActivities)) {
                event.label = event.label ? event.label + ', ' : '';
                event.label += afIncludedLabel(includeAssignFocusActivities);
              }
              dblAnalytics.eventTrack(action, event);
            },

            // format tracking value for play demo
            getDemoDetails: function(lessonGroup, includeAssignFocusActivities) {
              var result = lessonGroup.name + ', ' + lessonGroup.demo_lesson_name;

              if (includeAssignFocusActivities !== null) {
                result += (', ' + afIncludedLabel(includeAssignFocusActivities));
              }
              return result;
            },

            // return locations for PD content
            getPdLocations: getPdLocations,

            // return details for PD content
            getPdContents: getPdContents,

            isMoodleUrl: isMoodleUrl,

            retrievePdLocations: retrievePdLocations,
          };
        }
      ]
    };

    return provider;
  });
